import { FC, HTMLAttributes, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Popover } from 'antd';

import { MenuIcon } from 'entities/Notification';
import { NotificationsPopup } from 'features/NotificationsPopup';
import { useCommonSlice, useMedia } from 'shared/hooks';

interface INotificationsProps extends HTMLAttributes<HTMLDivElement> {}

export const Notifications: FC<INotificationsProps> = () => {
	const { notificationsModalIsOpened, setNotificationsModalIsOpened } = useCommonSlice();
	const isMd = useMedia();

	const { pathname } = useLocation();

	useEffect(() => {
		setNotificationsModalIsOpened(false);
	}, [pathname]); // eslint-disable-line

	return (
		<Popover
			open={notificationsModalIsOpened}
			onOpenChange={setNotificationsModalIsOpened}
			align={{ offset: isMd ? [-10, 10] : [2, 10] }}
			placement={isMd ? 'bottom' : 'bottomLeft'}
			content={<NotificationsPopup />}
			trigger={'click'}
			destroyTooltipOnHide>
			<MenuIcon />
		</Popover>
	);
};
